// 默认强度
export const useReferenceColorWeight = 0.50; // 使用颜色参考

export const notUseReferenceColorWeight = 0.58; // 不使用颜色参考

export const poseWeight = 1; // 姿势

export const fluxWeight = 0.17; // Holopix模型

// 重绘幅度
export const redrawWeightDefault = 2;

export const redrawWeightMin = 1;

export const redrawWeightMax = 4;

// 默认生图数量
export const defaultBatchSize = 1;

// 默认选中生图尺寸
export const defaultAspectRatios = '3:4';

// 高清修复默认倍数
export const defaultHD = 1.5;

// 画面增强
export const defaultPerturb = 3;

// 默认模型 id
export const defaultModelId = ['production', 'gray'].includes(import.meta.env.VITE_ENV) ? 408 : 185;

// 默认 HolopixV1 模型 id
export const defaultFluxModelId = ['production', 'gray'].includes(import.meta.env.VITE_ENV) ? 143 : 188;

// 新手引导默认模型id
export const guideModelId = ['production', 'gray'].includes(import.meta.env.VITE_ENV) ? 143 : 173
